'use strict';

import _ from 'lodash';

export default function () {
    var _element = null, _outer = null, _inner = null;
    return {
        link: function (scope, element, attr, ngModel) {
            _element = element;
            
        },
        controller: function ($scope, $http, $sce, $interval, $timeout) {
            'ngInject';


            function _getLogos() {
                $http({
                    url: '/api/testimonial/getlogos',
                    method: 'get',
                    params: { gray: $scope.element.data.gray, tag: $scope.element.data.tag }
                })
                    .then(function Success(result) {
                        $scope.logos = [];
                        angular.forEach(result.data, function (item) {
                            $scope.logos.push({
                                image: item,
                                fade: 0
                            });
                        });
                    }, function Fail(result) {
                        console.log("GetLogos Failed: " + result);
                    });
            };

            $scope.$watch("element.data.gray", _getLogos);

            $scope.scrolling = false;
            $scope.keepScrolling = false;

            $scope.ScrollDown = function () {
                if (!$scope.scrolling) {
                    var nextHeight = _findNextHiddenHeight();
                    _inner.css({ top: 0 - nextHeight });
                    $scope.scrolling = true;

                    _inner.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", _finishScroll);
                    //$timeout(_finishScroll, 1000);
                } else {
                    $scope.keepScrolling = true;
                }
                //$interval(_setArrows, 1);
                
            };

            function _finishScroll() {
                _inner.addClass("LogoInnerInstant");
                //$timeout(() => {
                    _removeHidden();
                    _inner.css({ top: 0 });
                    $timeout(() => {
                        _inner.removeClass("LogoInnerInstant");
                        $scope.scrolling = false;
                        if ($scope.keepScrolling) {
                            $scope.keepScrolling = false;
                            $scope.ScrollDown();
                        }
                    }, 1);
                //}, 1);
            }

            function _removeHidden() {
                var height = _outer.height();
                var hide = [];
                _element.find("img").each((index, element) => {
                    console.log($(element).position().top < height);
                    if ($(element).position().top < height) {
                        hide.push(element);
                    }
                });
                //$scope.logos = _.slice($scope.logos, hide.length);
                //console.log(hide);
                _.forEach(hide, (item) => {
                    _inner.append($(item).remove());
                });
            }
            //$scope.ScrollUp = function () {
            //    _inner.css({ top: _inner.position().top + _outer.height() });
            //    $interval(_setArrows, 1);
            //};


            var checker = $interval(() => {
                if (_outer === null && _element !== null) {
                    _outer = _element.find(".Logos");
                    _inner = _element.find(".LogoInner");
                    clearInterval(checker);
                }
            }, 1000);

            function _findNextHiddenHeight() {
                var height = _outer.height();
                var nextHeight = null;
                _element.find("img").each((index, element) => {
                    if ($(element).position().top >= height) {
                        nextHeight = $(element).position().top;
                        return false;
                    }
                });
                return nextHeight;
                //console.log(nextHeight);
            }

            //function _setArrows() {
            //    var outerHeight = _outer.height();
            //    var innerHeight = _inner.height();
            //    console.log(innerHeight > outerHeight, -_inner.position().top + _outer.height(), innerHeight, _inner.position().top);


            //    if (innerHeight > outerHeight) {
            //        if (-_inner.position().top + _outer.height() < innerHeight) {
            //            _element.find(".DownArrow").fadeTo(0, 1);
            //        } else {
            //            _element.find(".DownArrow").fadeTo(0, 0);
            //        }
            //        //if (_inner.position().top < 0) {
            //        //    _element.find(".UpArrow").fadeTo(0, 1);
            //        //} else {
            //        //    _element.find(".UpArrow").fadeTo(0, 0);
            //        //}
            //    }
            //}
        },
        template: require('./logos.html')
    };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/logos.js